import { PRIMARY_BLUE, WHITE_TEXT } from 'styles/Colors';
import {
  TURNUP_EVEN,
  TURNUP_ONE_MAIN,
  TURNUP_QUINSTREET
} from 'helpers/Constants';
import React from 'react';

const headerStyle = {
  padding: '0.5rem',
  backgroundColor: PRIMARY_BLUE,
  color: WHITE_TEXT,
  textAlign: 'center',
  fontWeight: 'bold'
};

const pStyle = {
  paddingBottom: '0.5rem'
};

const oneMainBulletStyle = {
  paddingLeft: '2rem'
};

const EVEN_QUINSTREET_HEADER = 'Authorization for Lower Rate Comparison';
const headers = {
  [TURNUP_EVEN]: EVEN_QUINSTREET_HEADER,
  [TURNUP_QUINSTREET]: EVEN_QUINSTREET_HEADER,
  [TURNUP_ONE_MAIN]: 'I want to see if I qualify for a lower rate'
};

export function TurnupHeader({ vendor }) {
  const text = headers[vendor];

  return <h3 css={headerStyle}>{text}</h3>;
}

function TurnupLink({ children, href }) {
  return (
    <a href={href} rel='noreferrer' target='_blank'>
      {children}
    </a>
  );
}

function EvenQuinstreetBody() {
  return (
    <div>
      <p css={pStyle}>
        By checking the box below and clicking “Agree and Apply Now,” you
        authorize OppLoans to share your personal information with third
        parties, including QuinStreet, Inc./AmOne and Engine, to potentially
        receive loan product offers through these parties. You consent that you
        are providing written consent under the Fair Credit Reporting Act for
        the listed companies and their partners to obtain consumer report
        information from your credit profile.
      </p>

      <p css={pStyle}>
        You agree to be contacted by AmOne, Engine, and their partners at the
        telephone number(s) and/or email address(es) you have provided to
        explore personal loan offers, including telephone, text messages and/or
        email. Consent is not required as a condition to purchase goods and
        services from any listed third party.
      </p>

      <p css={pStyle}>
        Additionally, you further acknowledge that you have read and consent to
        the following:
        <br />
        <TurnupLink href='https://engine.tech/resources/legal#terms'>
          Engine - Terms of Service
        </TurnupLink>
        <br />
        <TurnupLink href='https://engine.tech/resources/legal#privacy'>
          Engine - Privacy Policy
        </TurnupLink>
        <br />
        <TurnupLink href='https://engine.tech/resources/legal#consent'>
          Engine - Electronic Consent
        </TurnupLink>
        <br />
        <TurnupLink href='https://engine.tech/resources/legal#credit'>
          Engine - Credit Authorization
        </TurnupLink>
        <br />
        <TurnupLink href='https://www.quinstreet.com/terms-of-use/'>
          QuinStreet - Terms of Use
        </TurnupLink>
        <br />
        <TurnupLink href='https://www.quinstreet.com/privacy-notice/'>
          Quinstreet - Privacy Notice
        </TurnupLink>
      </p>

      <p css={pStyle}>
        OppLoans does not guarantee the accuracy or completeness of any
        information presented on these third party sites, nor does OppLoans
        represent either you or the third party should you enter into a
        transaction. All credit decisions on the third party site, including
        loan approval, are the responsibility of the participating lenders and
        may vary based upon your individual situation.
      </p>
    </div>
  );
}

function OneMainBody() {
  return (
    <div>
      <p css={pStyle}>By checking the box below:</p>
      <ul css={oneMainBulletStyle}>
        <li>
          You are authorizing OppLoans to share your personal information with a
          third-party so that you may potentially receive loan product offers
          through OneMain Financial. OneMain Financial offers secured and
          unsecured loans.
        </li>
        <li>
          <span>You have reviewed, agree to and acknowledge their&nbsp;</span>
          <TurnupLink href='https://www.onemainfinancial.com/legal/terms-of-use'>
            Terms of Use
          </TurnupLink>
          <span>,&nbsp;</span>
          <TurnupLink href='https://www.onemainfinancial.com/legal/e-consent'>
            Electronic Consent Agreement
          </TurnupLink>
          <span>,&nbsp;</span>
          <TurnupLink href='https://www.onemainfinancial.com/legal/privacy-notice'>
            Privacy Notice
          </TurnupLink>
          <span>,&nbsp;</span>
          <TurnupLink href='https://www.onemainfinancial.com/legal/privacy-policy'>
            Privacy Policy
          </TurnupLink>
          <span>, and&nbsp;</span>
          <TurnupLink href='https://www.onemainfinancial.com/legal/informational-communications-authorization'>
            Informational Communications Authorization
          </TurnupLink>
          <span>.</span>
        </li>
        <li>
          <span>You agree to and acknowledge their&nbsp;</span>
          <TurnupLink href='https://www.onemainfinancial.com/prequalification#prequalTerms'>
            Important Prequalified Offer Information and Conditions
          </TurnupLink>
          <span>.</span>
        </li>
        <li>
          You are providing written instructions to OneMain, under the Fair
          Credit Reporting Act, to obtain your consumer report information from
          any consumer reporting agency to prequalify you for a loan.
        </li>
        <li>
          You consent and agree that OneMain Financial may share your personal
          information with OppLoans, including approval status, funded status
          and loan terms, for purposes of analytics and to validate OneMain
          Financial&apos;s compliance with OppLoans&apos; guidelines. Opploans
          may receive compensation from OneMain Financial.
        </li>
        <li>
          You confirm that you can receive and access electronic records,
          including the ability to receive email and access PDF files.
        </li>
      </ul>
    </div>
  );
}

const bodies = {
  [TURNUP_EVEN]: EvenQuinstreetBody,
  [TURNUP_QUINSTREET]: EvenQuinstreetBody,
  [TURNUP_ONE_MAIN]: OneMainBody
};

export function TurnupBody({ vendor }) {
  const Body = bodies[vendor];

  return <Body />;
}

const EVEN_QUINSTREET_FOOTER = `I have reviewed the above disclosures, I consent
  to the stated terms, and I authorize OppLoans to share my information with the
  aforementioned entities to see if I qualify for a lower rate.`;
const footers = {
  [TURNUP_EVEN]: EVEN_QUINSTREET_FOOTER,
  [TURNUP_QUINSTREET]: EVEN_QUINSTREET_FOOTER,
  [TURNUP_ONE_MAIN]: `I authorize Opploans to check if I qualify for a lower rate with
    OneMain Financial. OneMain Financial is not an Opploans direct lending
    partner. All OneMain Financial loans are originated and serviced by OneMain
    Financial.`
};

export function TurnupFooter({ vendor }) {
  const text = footers[vendor];

  return <span>{text}</span>;
}
